import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import theme from 'shared/styles/theme';

const ExpressiveXXSText = forwardRef<Text, TextProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Text ref={ref} style={[styles.expressiveXXSText, style]} {...props}>
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  expressiveXXSText: {
    ...theme.typography.expressive.xxs,
  },
});

export default ExpressiveXXSText;
